export const SCOPE = 'content-preview';
